var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChazuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 557",
    d: "M8 3V7",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 558",
    d: "M4 9V11",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 559",
    d: "M12 9V11",
    stroke: "black",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChazuo);
export default __webpack_public_path__ + "static/media/chazuo.01ec9cbda89965b72b326741e1badeb4.svg";
export { ForwardRef as ReactComponent };